import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateGeosuggestLanguageSettings } from '../../../redux/actions/UtilsActions';

import LoadingSpinner from '../util/LoadingSpinner';

import { LanguageTypes } from '../../../lib/constants';

class GeoSuggestWrapper extends React.Component {

    constructor(props) {
        super(props);

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isIsraeli !== this.props.isIsraeli && ((nextProps.isIsraeli && this.props.languageSettings.language !== 'iw') || (!nextProps.isIsraeli && this.props.languageSettings.language === 'iw'))) {
            this.updateLanguage(nextProps.isIsraeli ? LanguageTypes.Hebrew : LanguageTypes.English);
        }
    }

    updateLanguage(lang) {
        window.google = undefined;
        this.props.actions.updateGeosuggestLanguageSettings({ language: lang, loading: true });
    }

    componentWillMount() {
        //need this bec cwrp isn't called on the initial "render" the first time props are passed through, 
        // and that doesn't work for the edit application/recipient details.
        if ((this.props.isIsraeli && this.props.languageSettings.language !== LanguageTypes.Hebrew) || (!this.props.isIsraeli && this.props.languageSettings.language !== LanguageTypes.English)) {
            this.updateLanguage(this.props.isIsraeli ? LanguageTypes.Hebrew : LanguageTypes.English);
        }
    }
    render() {
        return (
            <div className="full-width">
                {window.google && !this.props.languageSettings.loading ? this.props.children
                    : <LoadingSpinner height="12" />}
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        languageSettings: state.utils.geosuggestLanguageSettings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ updateGeosuggestLanguageSettings }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoSuggestWrapper);




// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/GeoSuggestWrapper.jsx